import { render, staticRenderFns } from "./ProductPackageSelector.vue?vue&type=template&id=081f07e6&scoped=true&"
import script from "./ProductPackageSelector.vue?vue&type=script&lang=js&"
export * from "./ProductPackageSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProductPackageSelector.vue?vue&type=style&index=0&id=081f07e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f07e6",
  null
  
)

export default component.exports